/**
 * 테이블 세션이 쓰는 sessionStorage 키 — 값만 있는 모듈.
 *
 * ## 왜 `tableContext` 에서 뺐는가
 *
 * `tableContext` 는 세션 복구·검증 로직이 두꺼워서 테스트가 통째로 모킹한다. 상수가 그
 * 뒤에 있으면, 그 상수를 쓰는 **다른 모듈까지** 모킹의 사정권에 들어간다 — 실제로
 * 좌석 토큰 상수를 `tableContext` 에 두었더니 7개 테스트가 "export 가 없다" 로 깨졌다.
 *
 * 값만 있는 모듈은 모킹할 이유가 없으므로, 여기 두면 그 연쇄가 끊긴다.
 */

/**
 * 좌석 참여자 토큰 — 분할결제의 `X-Comensal-Token` (menu #814).
 *
 * 테이블 세션에 매인 값이라 세션이 바뀌면 함께 버린다. `TABLE_SESSION_RUNTIME_KEYS` 에
 * 포함되어 `clearTableSession()` 이 함께 지운다.
 */
export const COMENSAL_DEVICE_TOKEN_KEY = 'comensal_device_token';

/**
 * 현재 좌석 참여자의 최소 권한 스냅샷.
 *
 * 장바구니처럼 React 트리상 `useComensalSession` 보다 위에 있는 경계도 D2 권한을
 * fail-closed 로 적용해야 하므로 저장한다. 서버 권위 값은 앱 진입/새로고침 때
 * `GET /table-sessions/{token}/comensal` 로 즉시 다시 확인한다.
 */
export const COMENSAL_ACCESS_SNAPSHOT_KEY = 'comensal_access_snapshot';

/** 분할결제 유효 가용성 — admin 의 정책 AND release gate 판정값. */
export const SPLIT_PAYMENT_AVAILABLE_KEY = 'split_payment_available';

/** 활성 split 세션에 합류하기 위한 2분짜리 view-only entry 스냅샷. */
export const TABLE_SESSION_ENTRY_KEY = 'olulo_table_session_entry_v1';

/** 참여자 역할·합류 상태가 바뀌었음을 같은 탭의 소비자에게 알린다. */
export const COMENSAL_ACCESS_CHANGED_EVENT = 'olulo:comensal-access-changed';

/** 한 화면의 claim 이후 다른 Bill 소비자가 서버 상태를 다시 읽게 한다. */
export const SESSION_BILLS_CHANGED_EVENT = 'olulo:session-bills-changed';

/**
 * 테이블 세션 토큰 변경(설정/삭제) 시 발행하는 이벤트.
 *
 * sessionStorage 는 같은 탭 내 변경에 대해 `storage` 이벤트를 발생시키지 않아 반응형이
 * 아니다. 토큰 기반 UI 가 이 이벤트를 구독한다.
 */
export const TABLE_SESSION_CHANGED_EVENT = 'olulo:table-session-changed';
